import React from 'react';
import {StyleSheet, View, FlatList, Platform} from 'react-native';
import {useSelector} from 'react-redux';
import {appBackgroundWhiteBG, isWindows} from '../../utils/utils';
import {BrowseListItem} from './BrowseListItem';
import {selectScreenOrientation} from '../../redux/slices/ScreenOrientationSlice';
import {useNavigation} from '@react-navigation/native';
import {isNewAPI} from '../../utils/utils';

const rightMargin = Platform.OS === 'macos' ? 14.9 : 16;

export const BrowseList = props => {
   const navigation = useNavigation();
   const isLandscapeMode = useSelector(selectScreenOrientation);
   const browseList = props.browseListData;
   const numColumns = isLandscapeMode ? 3 : 1;
   const render = ({item, index}) => {
      return (
         <BrowseListItem
            item={item}
            navigation={navigation}
            index={index}
            num={browseList?.length}
            emptyCard={
               browseList?.length % numColumns > 0
                  ? numColumns - (browseList?.length % numColumns)
                  : 0
            }
         />
      );
   };
   return (
      <View
         style={[
            styles.container,
            {
               ...Platform.select({
                  web: {
                     marginEnd: isLandscapeMode ? 0 : 10,
                     marginLeft: isLandscapeMode ? 8 : 10,
                     marginTop: 0,
                  },
                  android: {
                     paddingTop: isLandscapeMode ? 16 : 8,
                     paddingHorizontal: isLandscapeMode ? 16 : 8,
                     marginEnd: null,
                     marginLeft: null,
                     marginTop: null,
                     marginBottom: null,
                  },
                  ios: {
                     paddingTop: isLandscapeMode ? 16 : 8,
                     paddingHorizontal: isLandscapeMode ? 16 : 10,
                     marginEnd: null,
                     marginLeft: null,
                     marginTop: null,
                     marginBottom: isLandscapeMode ? null : 10,
                  },
               }),
            },
         ]}>
         <FlatList
            style={{
               paddingRight: isWindows ? 16 : null,
               paddingBottom: Platform.OS === 'android' ? 8 : 0,
               ...Platform.select({
                  web: {
                     paddingRight: isLandscapeMode ? 8 : 0,
                     paddingBottom: isLandscapeMode ? 0 : null,
                     marginTop: 8,
                  },
                  macos: {
                     marginBottom: null,
                  },
               }),
            }}
            data={browseList}
            removeClippedSubviews={Platform.OS === 'macos' ? false : true}
            renderItem={render}
            numColumns={numColumns}
            keyExtractor={item => item.ID}
            key={isLandscapeMode ? 'l' : 'p'}
         />
      </View>
   );
};
const styles = StyleSheet.create({
   container: {
      flex: 1,
      marginTop: 16,
      justifyContent: 'center',
      marginLeft: 16,
      marginEnd: isWindows ? null : rightMargin,
   },
});
